import { render } from "./Coupon.vue?vue&type=template&id=4fb6683f&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=4fb6683f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb6683f"]])

export default __exports__